module.exports = __webpack_public_path__ + "media/images/weather/114_night-057bea34696ad6eced59ba2816001503.png";